import { render, staticRenderFns } from "./deleteBuilding.vue?vue&type=template&id=06041f49&scoped=true"
import script from "./deleteBuilding.vue?vue&type=script&lang=js"
export * from "./deleteBuilding.vue?vue&type=script&lang=js"
import style0 from "./deleteBuilding.vue?vue&type=style&index=0&id=06041f49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06041f49",
  null
  
)

export default component.exports